<template>
  <div class="language">
    <span
      class="language-title"
      @click="selectLanguage()"
      >
      言語 Language
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    selectLanguage: function () {
      this.$store.dispatch('popup/show', 'language')
    }
  }
}
</script>

<style lang="scss" scoped>
.language {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  color: white;
  margin: 10px;
}

.language-title {
  &:hover {
    border-bottom: 1px solid white;
    cursor: pointer;
  }
}
</style>
